import React, { useState } from 'react';
import {
  FaEnvelope, FaWhatsapp, FaMapMarkerAlt, FaBriefcase,
  FaLinkedinIn, FaGithub, FaPaperPlane, FaCheckCircle, FaExclamationCircle,
} from 'react-icons/fa';
import { FaSpinner } from 'react-icons/fa6';
import SectionTitle from '../components/shared/SectionTitle';
import '../styles/contact.css';

const EMAILJS_SERVICE_ID  = 'service_f9612jw';
const EMAILJS_TEMPLATE_ID = 'template_tjrro6s';
const EMAILJS_PUBLIC_KEY  = 'OiDUAJbG4kYe0_aMt';

function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          service_id: EMAILJS_SERVICE_ID,
          template_id: EMAILJS_TEMPLATE_ID,
          user_id: EMAILJS_PUBLIC_KEY,
          template_params: { from_name: formData.name, from_email: formData.email, subject: formData.subject, message: formData.message },
        }),
      });
      if (res.ok) { setStatus('success'); setFormData({ name: '', email: '', subject: '', message: '' }); }
      else throw new Error();
    } catch { setStatus('error'); }
  };

  const details = [
    { icon: <FaEnvelope />,      label: 'Email',           value: 'hardyyaqub@gmail.com',        href: 'mailto:hardyyaqub@gmail.com' },
    { icon: <FaWhatsapp />,      label: 'WhatsApp / Phone', value: '+233 556 387 424',             href: 'https://wa.me/233556387424' },
    { icon: <FaMapMarkerAlt />,  label: 'Location',        value: 'Wa, Upper West Region, Ghana', href: null },
    { icon: <FaBriefcase />,     label: 'Freelance',       value: 'Available on Upwork',          href: null },
  ];

  const socials = [
    { icon: <FaLinkedinIn />, href: 'https://www.linkedin.com/in/haadi-yakubu', label: 'LinkedIn' },
    { icon: <FaGithub />,     href: 'https://github.com/Hardy999',              label: 'GitHub' },
    { icon: <FaWhatsapp />,   href: 'https://wa.me/233556387424',               label: 'WhatsApp' },
    { icon: <FaEnvelope />,   href: 'mailto:hardyyaqub@gmail.com',              label: 'Email' },
  ];

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <SectionTitle label="Let's Talk" title="Get In Touch" />
        <div className="contact__layout">

          <div className="contact__info">
            <p className="contact__tagline">
              I'm currently open to new opportunities — full-time roles, freelance projects,
              or just a conversation about data. My inbox is always open.
            </p>
            <div className="contact__details">
              {details.map((item) => (
                <div className="contact__detail-item" key={item.label}>
                  <div className="contact__detail-icon">{item.icon}</div>
                  <div>
                    <p className="contact__detail-label">{item.label}</p>
                    <p className="contact__detail-value">
                      {item.href ? <a href={item.href}>{item.value}</a> : item.value}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="contact__social">
              {socials.map((s) => (
                <a key={s.label} href={s.href} target={s.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer" aria-label={s.label}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <form className="contact__form" onSubmit={handleSubmit} noValidate>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" name="name" placeholder="John Doe" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" name="email" placeholder="john@example.com" value={formData.email} onChange={handleChange} required />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input type="text" id="subject" name="subject" placeholder="Job Opportunity / Collaboration / Other" value={formData.subject} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" placeholder="Tell me about your project or opportunity..." value={formData.message} onChange={handleChange} required></textarea>
            </div>
            <button type="submit" className="form__submit" disabled={status === 'sending'}>
              {status === 'sending'
                ? <><FaSpinner className="spin" /> Sending...</>
                : <><FaPaperPlane /> Send Message</>}
            </button>
            {status === 'success' && <p className="form__status success"><FaCheckCircle /> Message sent! I'll get back to you soon.</p>}
            {status === 'error'   && <p className="form__status error"><FaExclamationCircle /> Something went wrong. Email me at hardyyaqub@gmail.com</p>}
          </form>

        </div>
      </div>
    </section>
  );
}

export default Contact;